<template>
  <div class="message-box">
    <b-modal ref="modal-window" :title="$t('showObjectInfo.title')" size="lg modal-fullscreen-xxl-down" modal-class="message-box-modal" :loading="loading">
      <template #modal-body>
        <text-field
            v-model="object.name"
            required
            :error="v$.object.name.$error ? $t('showObjectInfo.error.name') : serverErrors.name ? serverErrors.name[0] : ''"
            :label="$t('showObjectInfo.name')"
        />

        <text-field
            v-model="object.vehicleNumber"
            required
            :error="v$.object.vehicleNumber.$error ? $t('showObjectInfo.error.vehicleNumber') : serverErrors.vehicleNumber
              ? serverErrors.vehicleNumber[0]
              : ''"
            :label="$t('showObjectInfo.vehicleNumber')"
        />

        <Textarea v-model="object.comment" :label="$t('client.comment')" :rows="3" />
        <div class="my-2">
          <SwitchField v-model="object.isBillingEnabled" :label="$t('showObjectInfo.billingEnabled')" size="lg" />
        </div>
        <div class="mb-2">
          <SwitchField v-model="object.isRedefinePrice" :label="$t('showObjectInfo.redefinePrice')" size="lg" />
        </div>

        <template v-if="object.isRedefinePrice">
          <NumberField
            v-model="object.price"
            :label="$t('showObjectInfo.price')"
            required
            :error="v$.object.price.$error ? $t('showObjectInfo.error.price') : serverErrors.price ? serverErrors.price[0] : ''"
          />
        </template>

        <NumberField v-model="object.cost" :label="$t('showObjectInfo.cost')" />
        <div class="mb-2">
          <SwitchField v-model="object.isFeatureEnabled" :label="$t('showObjectInfo.featureEnabled')" size="lg" />
        </div>

        <template v-if="object.isFeatureEnabled">
          <text-field
              v-model="object.featureName"
              required
              :error="v$.object.featureName.$error ? $t('showObjectInfo.error.featureName') : ''"
              :label="$t('showObjectInfo.featureName')"
          />

          <NumberField
              v-model="object.featurePrice"
              :label="$t('showObjectInfo.featurePrice')"
              required
              :error="v$.object.featurePrice.$error ? $t('showObjectInfo.error.featurePrice') : ''"
          />
        </template>

        <DatePickerField
            v-model="object.nextBillDate"
            required
            :isMonthMode="true"
            :label="$t('showObjectInfo.nextBillDate')"
            :error="v$.object.nextBillDate.$error ? $t('showObjectInfo.error.featureName') : ''"
        />

        <label class="form-label">{{ $t('showObjectInfo.updateDate') }}</label>
        {{ object.datetimeUtc }}
      </template>

      <template #modal-footer>
        <span class="btn btn-secondary" @click="close()">{{ $t('client.cancel') }}</span>
        <span class="btn btn-primary" @click="submit()">{{ $t('client.create') }}</span>
      </template>
    </b-modal>
  </div>
</template>

<script src="./showObjectInfo.js">
</script>
